import React from "react";
import { useParams } from "react-router-dom";
import { Box, CardBody, CardHeader, Divider, VStack } from "@chakra-ui/react";
import { useFetchBlocksReserveByRestaurantId } from "../../../hooks/blocksReserve/useFetchBlocksReserveByRestaurantId";
import { SettingItem } from "../../organisms/SettingItem";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { SettingsIcon } from "@chakra-ui/icons";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { RestaurantSettingCardFooter } from "../../organisms/restaurant/RestaurantSettingCardFooter";

export const BlocksReserveSetting = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const { reserveSetting, isLoading } = useFetchBlocksReserveByRestaurantId(restaurantId);

    if (isLoading) return <CircularLoading />;

    const path = reserveSetting ? `edit` : `edit`;
    const gSettingsDetails = [
        { label: "ID", value: reserveSetting?.reserve_id ?? "未登録" },
        { label: "パスワード", value: reserveSetting?.password ?? "未登録" },
    ];

    return (
        <DarkShadowCard w="100%">
            <CardHeader pb={0}>
                <CardHeading icon={<SettingsIcon />} heading="BLOCKsリザーブ設定" />
            </CardHeader>
            <CardBody>
                <VStack align="start" fontSize="sm" fontWeight="bold" spacing={4} w="100%">
                    <Divider my={0} />
                    {gSettingsDetails.map((detail) => (
                        <React.Fragment key={detail.label}>
                            <Box w="100%">
                                <SettingItem label={detail.label} content={detail.value} />
                            </Box>
                            <Divider my={0} />
                        </React.Fragment>
                    ))}
                </VStack>
            </CardBody>
            <RestaurantSettingCardFooter path={path} />
        </DarkShadowCard>
    );
};